/**
 * @fileoverview 認証コレクション collection
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
// Collection Import
import CommonCollection from './CommonCollection';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import ConnectionUtil from '../util/ConnectionUtil';

/**
 * 認証コレクション
 *
 * @class AuthenticationCollection
 * @extends {CommonCollection}
 */
class AuthenticationCollection extends CommonCollection {
  /**
   * Creates an instance of AuthenticationCollection.
   * @memberof AuthenticationCollection
   */
  constructor() {
    super();
  }

  /**
   *  ログイン
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof AuthenticationCollection
   */
  login(callback, payload) {
    this.loginCallback = callback;
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    let self = this;
    ConnectionUtil.callAPI(
      ConstUtil.Common.API_LIST.A01,
      request,
      ConstUtil.Common.TIMEOUT.DEFAULT,
      function(err, res) {
        if (err) {
          self.loginCallback.failure(err);
          return;
        }
        self.setResponseData(res.data);
        return;
      }
    );
  }

  /**
   *  ログアウト
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof AuthenticationCollection
   */
  logout(callback, payload) {
    this.logoutCallback = callback;
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    let self = this;
    ConnectionUtil.callAPI(
      ConstUtil.Common.API_LIST.A02,
      request,
      ConstUtil.Common.TIMEOUT.DEFAULT,
      function(err, res) {
        if (err) {
          self.logoutCallback.failure(err);
          return;
        }
        self.logoutCallback.success();
        return;
      }
    );
  }

  /**
   * レスポンスデータのセット
   *
   * @param {Object} responseData レスポンスデータ
   * @memberof AuthenticationCollection
   */
  setResponseData(responseData) {
    // ローカルストレージに権限IDを保存
    localStorage.setItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID,
      responseData.authority_id
    );
    // アカウントIDの保存
    localStorage.setItem(
      ConstUtil.Common.STORAGE_KEY.ACCOUNT_ID,
      responseData.id
    );
    // トークンを保存
    localStorage.setItem(
      ConstUtil.Common.STORAGE_KEY.TOKEN,
      responseData.token
    );
    // センター情報がある場合
    if (!_.isEmpty(responseData.center_info)) {
      // センターIDを保存
      localStorage.setItem(
        ConstUtil.Common.STORAGE_KEY.CENTER_ID,
        responseData.center_info.id
      );
      // センタードメインを保存
      localStorage.setItem(
        ConstUtil.Common.STORAGE_KEY.CENTER_DOMAIN,
        responseData.center_info.domain
      );
    }
    this.loginCallback.success();
  }
}
export default AuthenticationCollection;



// WEBPACK FOOTER //
// ./src/js/collection/AuthenticationCollection.jsx